import type { CartItem } from '@/types/cart';
import { getLocalizedText } from '@/utils/getLocalizedText';
import { useTranslation } from 'react-i18next';

interface ReceiptItemsProps {
  items: CartItem[];
}

export function ReceiptItems({ items }: ReceiptItemsProps) {
  const { i18n } = useTranslation('customer');
  const isRTL = i18n.language === 'ar';
  const currentLanguage = (i18n.language === 'ar' ? 'ar' : 'en') as 'ar' | 'en';

  return (
    <div className="space-y-2">
      {/* Table Header */}
      <div className={`flex text-xs font-semibold border-b border-gray-300 ${isRTL ? 'flex-row-reverse' : ''}`}>
        <div className="flex-1 text-left rtl:text-right">
          {isRTL ? 'العنصر' : 'Item'}
        </div>
        <div className="w-12 text-center">
          {isRTL ? 'الكمية' : 'Qty'}
        </div>
        <div className="w-20 text-right rtl:text-left">
          {isRTL ? 'السعر' : 'Price'}
        </div>
        <div className="w-24 text-right rtl:text-left">
          {isRTL ? 'الإجمالي' : 'Total'}
        </div>
      </div>

      {/* Items */}
      {items.filter(item => item.quantity > 0).map((item) => {
        const itemName = getLocalizedText(item, 'name', currentLanguage);
        const unitPriceEGP = (item.unitPrice / 100).toFixed(1);
        const lineTotalEGP = (item.lineTotal / 100).toFixed(1);

        return (
          <div
            key={item.id}
            className={`flex text-sm border-b border-dashed border-gray-200 pb-2 ${isRTL ? 'flex-row-reverse' : ''}`}
          >
            {/* Item Name */}
            <div className="flex-1 text-left rtl:text-right min-w-0">
              <p className="font-semibold truncate">{itemName}</p>
              {item.specialInstructions && (
                <p className="text-xs text-muted-foreground italic mt-0.5">
                  {item.specialInstructions}
                </p>
              )}
            </div>

            {/* Quantity */}
            <div className="w-12 text-center">{item.quantity}</div>

            {/* Unit Price */}
            <div className="w-20 text-right rtl:text-left">
              {unitPriceEGP} EGP
            </div>

            {/* Line Total */}
            <div className="w-24 text-right rtl:text-left font-semibold">
              {lineTotalEGP} EGP
            </div>
          </div>
        );
      })}
    </div>
  );
}








